import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import i18n from 'i18n-js';
import commonStyles from '../../style/commonStyles';
import globalStyles from '../../style/global';

const hasText = value =>
  value !== null && value !== undefined && String(value).trim() !== '';

export const visibleOrderNotes = (order, scanPackSettings) => {
  if (!order || !scanPackSettings) return [];

  return [
    {key: 'tags', value: order.tags, enabled: scanPackSettings.show_tags},
    {
      key: 'notes_internal',
      value: order.notes_internal,
      enabled: scanPackSettings.show_internal_notes
    },
    {
      key: 'customer_comments',
      value: order.customer_comments,
      enabled: scanPackSettings.show_customer_notes
    },
    {
      key: 'notes_toPacker',
      value: order.notes_toPacker,
      enabled: scanPackSettings.show_internal_notes
    }
  ].filter(note => note.enabled && hasText(note.value));
};

export default function OrderNotesBar({notes, onClose}) {
  if (!notes || notes.length === 0) return null;

  return (
    <LinearGradient
      testID="orderNotesBar"
      locations={[0, 0.13, 1]}
      colors={['#000000', '#fdf359', '#d2c609']}
      style={globalStyles.nextItemNotes}>
      <View style={{width: '100%'}}>
        {notes.map((note, index) => (
          <View key={note.key} style={{width: '100%'}}>
            <Text
              testID={`orderNote-${note.key}`}
              style={commonStyles.nextItemText}>
              {note.value}
            </Text>
            {index < notes.length - 1 && (
              <View style={commonStyles.nextItemNotes} />
            )}
          </View>
        ))}
        <View>
          <TouchableOpacity
            testID="orderNotesGotIt"
            onPress={onClose}
            style={commonStyles.nextItemCloseNote}>
            <Text style={[commonStyles.nextItemText, {lineHeight: '100%'}]}>
              {i18n.t('nextItems.gotItLabel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </LinearGradient>
  );
}
